import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  AppBar,
  Toolbar,
  TextField,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import GlobalButton from "../../common/GlobalButton";
import BackWithArrow from "../../common/BackWithArrow";
import ViewKPIIconDesign from "../../common/ViewKPIIconDesign";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const dummyKPIs = [
  {
    kpi: "Scrap Rate Reduction",
    before: "5.2%",
    after: "2.3%",
    impact: "56% improvement",
  },
  {
    kpi: "Machine Downtime",
    before: "12 hrs/week",
    after: "4 hrs/week",
    impact: "66% reduction",
  },
  {
    kpi: "Defect Rate",
    before: "3.1%",
    after: "1.5%",
    impact: "51% improvement",
  },
  {
    kpi: "On-Time Delivery",
    before: "82%",
    after: "96%",
    impact: "17% improvement",
  },
  {
    kpi: "Energy Consumption",
    before: "5800 kWh/month",
    after: "4700 kWh/month",
    impact: "19% reduction",
  },
];

export default function ViewKPIImpactButton() {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filteredKPIs = dummyKPIs.filter((kpiRow) =>
    kpiRow.kpi.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <ViewKPIIconDesign
        variant="outlined"
        onClick={() => setOpen(true)}
      ></ViewKPIIconDesign>

      <Dialog fullScreen open={open} onClose={() => setOpen(false)}>
        <BackWithArrow onBack={() => setOpen(false)} />

        <DialogContent sx={{ p: 4 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" gutterBottom>
              Summary of Key Performance Indicators
            </Typography>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search KPI"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{ maxWidth: 300 }}
            />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell>
                    <strong>KPI</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Before CI</strong>
                  </TableCell>
                  <TableCell>
                    <strong>After CI</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Impact</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredKPIs.map((kpiRow, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{kpiRow.kpi}</TableCell>
                    <TableCell>{kpiRow.before}</TableCell>
                    <TableCell>{kpiRow.after}</TableCell>
                    <TableCell>{kpiRow.impact}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", p: 3 }}>
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#FFFFFF",
              color: "#4F46E5",
              "&:hover": {
                backgroundColor: "#4F46E5",
                color: "#FFFFFF",
              },
            }}
            startIcon={<RestartAltIcon color="#4F46E5" />}
          >
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
